import { render, staticRenderFns } from "./ProductListActions.vue?vue&type=template&id=66989104"
import script from "./ProductListActions.vue?vue&type=script&lang=js"
export * from "./ProductListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports